// API Configuration
const isProduction = process.env.NODE_ENV === 'production' || 
                     (window.location.hostname !== 'localhost' && 
                      window.location.hostname !== '127.0.0.1' && 
                      window.location.hostname !== '0.0.0.0');

// Allow override via env for dev/staging deployments on custom domains
// For Cloudflare Pages, set REACT_APP_API_BASE_URL if Worker is on different domain
const ENV_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const isLocalhost = 
  window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1' ||
  window.location.hostname === '0.0.0.0';

// API base URL resolution:
// 1. Use REACT_APP_API_BASE_URL if explicitly set (for Cloudflare Pages with separate Worker domain)
// 2. Use localhost:8787 for local development
// 3. Use window.location.origin for production (when Worker and Pages are on same domain)
const API_BASE_URL = ENV_API_BASE_URL || (
  isLocalhost ? 'http://localhost:8787' : window.location.origin
);

if (process.env.NODE_ENV === 'development') {
  console.log('API Configuration:', {
    NODE_ENV: process.env.NODE_ENV,
    hostname: window.location.hostname,
    isProduction,
    API_BASE_URL
  });
}

export const API_ENDPOINTS = {
  // Base URL
  API_BASE_URL,
  
  // Auth endpoints
  LOGIN: `${API_BASE_URL}/api/auth/login`,
  LOGOUT: `${API_BASE_URL}/api/auth/logout`,
  SIGNUP: `${API_BASE_URL}/api/auth/signup`,
  AUTH_REGISTER: `${API_BASE_URL}/api/auth/register`,
    VERIFY: `${API_BASE_URL}/api/auth/verify`,
    FORGOT_PASSWORD: `${API_BASE_URL}/api/auth/forgot-password`,
    RESET_PASSWORD: `${API_BASE_URL}/api/auth/reset-password`,
    
    // Upload endpoints
  UPLOAD: `${API_BASE_URL}/api/upload`,
  UPLOAD_FILE: `${API_BASE_URL}/api/upload`,
  LIST_UPLOADS: `${API_BASE_URL}/api/upload/company`,
  GET_FILE: `${API_BASE_URL}/api/upload`,
  GET_FILE_PREVIEW: `${API_BASE_URL}/api/file`,
  GET_FILE_ROWS: `${API_BASE_URL}/api/file`, // /api/file/:id/rows
  GET_FILE_DRAFT: `${API_BASE_URL}/api/file`, // /api/file/:id/draft
  SAVE_FILE_DRAFT: `${API_BASE_URL}/api/file`, // /api/file/:id/draft
  DELETE_FILE_DRAFT: `${API_BASE_URL}/api/file`, // /api/file/:id/draft
  TRANSLATE: `${API_BASE_URL}/api/upload/translate`,
  TRANSLATE_TEXT: `${API_BASE_URL}/api/upload/translate`,
  EXPORT_TAURUS: `${API_BASE_URL}/api/upload/export-taurus`,
  TAURUS_EXPORT: `${API_BASE_URL}/api/upload/export-taurus`,
  TAURUS_FIELDS: `${API_BASE_URL}/api/upload/taurus-fields`,
  
  // Demo endpoints removed
  
  // Exchange rate endpoints
  EXCHANGE_RATE: `${API_BASE_URL}/api/exchange-rate`,
  
  // Profile endpoints
  PROFILE: `${API_BASE_URL}/api/profile`,
  PROFILE_USER: `${API_BASE_URL}/api/profile/user`,
  PROFILE_COMPANY: `${API_BASE_URL}/api/profile/company`,
  PROFILE_VAT: `${API_BASE_URL}/api/profile/vat`,
  
  // Organization endpoints
  ORGANIZATION_MEMBERS: `${API_BASE_URL}/api/organization/members`,
  ORGANIZATION_INVITATIONS: `${API_BASE_URL}/api/organization/invitations`,
  ORGANIZATION_INVITE: `${API_BASE_URL}/api/organization/invite`,
  ORGANIZATION_REMOVE_MEMBER: `${API_BASE_URL}/api/organization/members`,
  ORGANIZATION_CHANGE_ROLE: `${API_BASE_URL}/api/organization/members`,
  ORGANIZATION_DELETE_INVITATION: `${API_BASE_URL}/api/organization/invitations`,
  ORGANIZATION_VALIDATE_INVITATION: `${API_BASE_URL}/api/organization/validate-invitation`,
  ORGANIZATION_ACCEPT_INVITATION: `${API_BASE_URL}/api/organization/accept-invitation`,
  
  // Invoice endpoints
  INVOICE_CREATE: `${API_BASE_URL}/api/invoice/create`,
  INVOICE_USER: `${API_BASE_URL}/api/invoice/user`,
  INVOICE_USER_BY_ID: `${API_BASE_URL}/api/invoice/user`,
  INVOICE_UPLOAD_RECEIPT: `${API_BASE_URL}/api/invoice`,
  INVOICE_CONFIRM_PAYMENT: `${API_BASE_URL}/api/invoice`,
  INVOICE_ADMIN_PENDING: `${API_BASE_URL}/api/invoice/admin/pending-payments`,
  INVOICE_ADMIN_ALL: `${API_BASE_URL}/api/admin/invoices`,
  INVOICE_ADMIN_APPROVE: `${API_BASE_URL}/api/invoice/admin`,
  INVOICE_ADMIN_REJECT: `${API_BASE_URL}/api/invoice/admin`,
  INVOICE_ADMIN_UPDATE_STATUS: `${API_BASE_URL}/api/admin/invoices`,
  INVOICE_ADMIN_STATS: `${API_BASE_URL}/api/invoice/admin/stats`,
  INVOICE_ADMIN_RESEND: `${API_BASE_URL}/api/invoice/admin`,
  INVOICE_ADMIN_DELETE: `${API_BASE_URL}/api/admin/invoices`,
  
  // Pay As You Go endpoints
  PAY_AS_YOU_GO_INTEREST: `${API_BASE_URL}/api/pay-as-you-go/interest`,
  PAY_AS_YOU_GO_INTERESTS: `${API_BASE_URL}/api/pay-as-you-go/interests`,
};

// Subscription configuration
export const SUBSCRIPTION_CONFIG = {
  DEFAULT_SUBSCRIPTION_DAYS: 365, // Default subscription period in days
};

// Pricing configuration - array of pricing plans
export const PRICING_PLANS = [
  {
    id: 'basic',
    nameKey: 'upgrade.basicPlan', // Translation key for plan name
    basePrice: 34899, // Base price in RSD (without VAT)
    currency: 'RSD',
    period: 'yearly', // 'yearly' or 'monthly'
    periodKey: 'upgrade.yearly', // Translation key for period
    // Plan limits
    maxFilesPerMonth: 25,
    maxUsers: 3,
    features: [
      { key: 'upgrade.unlimitedUploads' },
      { key: 'upgrade.upTo3Accounts' },
      { key: 'upgrade.taurusExport' },
      { key: 'upgrade.emailSupport' }
    ],
    badge: null, // Optional badge text (e.g., 'Most Popular')
    badgeKey: null, // Translation key for badge
    isPopular: false,
    style: {
      background: null, // null uses default card style
      gradient: null, // Optional gradient (e.g., 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)')
      borderColor: null, // Optional custom border color
      textColor: null, // Optional custom text color
    },
    buttonKey: 'upgrade.selectBasic', // Translation key for button text
  },
  {
    id: 'pro',
    nameKey: 'upgrade.proPlan',
    basePrice: 69999,
    currency: 'RSD',
    period: 'yearly',
    periodKey: 'upgrade.yearly',
    features: [
      { key: 'upgrade.allFromBasic' },
      { key: 'upgrade.unlimitedMembers' },
      { key: 'upgrade.prioritySupport' },
      { key: 'upgrade.customModels' },
      { key: 'upgrade.googleTranslateAccuracy' }
    ],
    badge: null,
    badgeKey: 'upgrade.mostPopular',
    isPopular: true,
    style: {
      background: null,
      gradient: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
      borderColor: '#667eea',
      textColor: 'white',
    },
    buttonKey: 'upgrade.selectPro',
  },
  {
    id: 'pay-as-you-go',
    nameKey: 'upgrade.payAsYouGoPlan',
    basePrice: null, // Custom pricing
    priceKey: 'upgrade.customPricing', // Translation key for custom price display
    currency: 'RSD',
    period: null,
    periodKey: 'upgrade.payAsYouGo',
    features: [
      { key: 'upgrade.payAsYouGoFeature1' },
      { key: 'upgrade.payAsYouGoFeature2' },
      { key: 'upgrade.payAsYouGoFeature3' },
      { key: 'upgrade.payAsYouGoFeature4' },
      { key: 'upgrade.payAsYouGoFeature5' },
      { key: 'upgrade.payAsYouGoFeature6' }
    ],
    badge: null,
    badgeKey: 'upgrade.comingSoon',
    isPopular: false,
    style: {
      background: null,
      gradient: null,
      borderColor: null,
      textColor: null,
      opacity: 0.9, // Slightly faded for "coming soon"
    },
    buttonKey: 'upgrade.clickHereIfInterested',
    isComingSoon: true, // Special flag for coming soon plans
    action: 'modal', // 'invoice' or 'modal' - opens modal instead of generating invoice
  }
];

// Media URLs
export const MEDIA_URLS = {
  // R2 public URL for hero video background
  // Hosted on Cloudflare R2 with custom domain: media.lizzardsolutions.com
  HERO_VIDEO: process.env.REACT_APP_HERO_VIDEO_URL || 'https://media.lizzardsolutions.com/media/video/6963965-hd_1920_1080_25fps.mp4',
};

// Cloudflare Turnstile Configuration
export const TURNSTILE_SITE_KEY = '0x4AAAAAAB03PJ26LR_Xrp6A';

export default API_ENDPOINTS; 